import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Col, Image, Row, Table } from "react-bootstrap";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import CustomSuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import SuperAdminSmsAdmin from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import { ChatScreenTrack } from "./ChatScreenTrack";
export const ViewOpenIssuesTicketRight = (props) => {
  const calcTotalPersons = (seating) => {
    var total;
    total =
      seating.adult_count +
      seating.kids_count +
      seating.high_chair +
      seating.handicap_chair;
    return total;
  };

  const waitTime =
    props &&
    props.logData &&
    props.logData.diner_id &&
    props.logData.diner_id.wait_time * 60 * 1000;

  const [logData, setLogData] = useState([]);

  useEffect(() => {
    if (props.logData && props.logData.ticketLogs && props.logData.ticketLogs) {
      const items = props.logData.ticketLogs;
      const reversedItems = items.map((item) => item).reverse();
      setLogData(reversedItems);
    }
  }, [props.logData.ticketLogs]);

  const makeCallingObject = (user) => {
    let formData = {};
    var mo = user && user.user_id && user.user_id.mobile_number;
    formData.user_details = {};
    formData.user_details.mobile_number =
      user && user.user_id && user.user_id.mobile_number;
    formData.user_details.country_code =
      user && user.user_id && user.user_id.country_code;
    formData.user_details.name =
      user && user.user_id && user.user_id.first_name;

    return formData;
  };

  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_right">
        <div className="open_issues_view_tickets_right_inside">
          <Row>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 pb-3">Track User Location</div>
              <div className="ml-4 pl-1">
                <Image
                  fluid
                  src={`${
                    props.actionBy === "ADMIN"
                      ? require("../../../../../assets/images/ActionImages/maps-and-flags.png")
                      : require("../../../../../assets/images/ActionImages/maps-and-flagsred.png")
                  }`}
                  alt="Location Icon"
                  width="13px"
                  title="Location"
                />
              </div>
            </Col>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 pb-3">Total PAX</div>
              <div className="adult-total-box">
                <div className="d-flex align-items-center">
                  <p className="f18-700 text-dark mr-2">
                    {" "}
                    {props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.adult_count ? (
                      calcTotalPersons(props.logData.diner_id)
                    ) : (
                      <> </>
                    )}
                  </p>
                  <div className="adult-total-box-two mr-2">
                    <div className="d-flex align-items-center justify-content-around mb-2">
                      <div className="adult-total-box-two-insideone">
                        <Image
                          src={require("../../../../../assets/images/ActionImages/employees.png")}
                          fluid
                          alt="Adult"
                          title="Adult"
                          className="icon-image"
                        />
                      </div>
                      <span className="pl-1">
                        {" "}
                        {props &&
                          props.logData &&
                          props.logData.diner_id &&
                          props.logData.diner_id.adult_count}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-around">
                      <div className="adult-total-box-two-insideone">
                        <Image
                          src={require("../../../../../assets/images/ActionImages/children.png")}
                          fluid
                          alt="Children"
                          title="Children"
                          className="icon-image"
                        />
                      </div>
                      <span className="pl-1">
                        {" "}
                        {props &&
                          props.logData &&
                          props.logData.diner_id &&
                          props.logData.diner_id.kids_count}
                      </span>
                    </div>
                  </div>
                  <div className="adult-total-box-three">
                    <div className="d-flex align-items-center justify-content-around mb-2">
                      <div className="adult-total-box-three-insideone">
                        <Image
                          src={require("../../../../../assets/images/ActionImages/highchair.png")}
                          fluid
                          alt="Highchair"
                          title="Highchair"
                          className="icon-image-small"
                        />
                      </div>
                      <span className="pl-1">
                        {props &&
                          props.logData &&
                          props.logData.diner_id &&
                          props.logData.diner_id.high_chair}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-around">
                      <div className="adult-total-box-three-insideone">
                        <Image
                          src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                          fluid
                          alt="Wheel Chair"
                          title="Wheel Chair"
                          className="icon-image-small"
                        />
                      </div>
                      <span className="pl-1">
                        {props &&
                          props.logData &&
                          props.logData.diner_id &&
                          props.logData.diner_id.handicap_chair}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 pb-3">Date / Time / Timer</div>
              <div className="f11-700 text-red">00:00:00</div>
              <div className="f9-500">HH:MM:SS</div>
            </Col>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 mb-3">Total wait time</div>
              <div className="d-flex justify-content-center align-items-center enTimesLbl">
                <Image
                  src={require("../../../../../assets/images/UserManagement/hourglass.svg")}
                  alt="Edit"
                  title="Edit"
                  width="9px"
                />
                {/* <span className="f10-500 text-dark pl-2">00 hh : 20 mins</span> */}
                {waitTime ? (
                  <span className="f10-500 text-dark pl-2">
                    {moment(
                      props &&
                        props.logData &&
                        props.logData.diner_id &&
                        props.logData.diner_id.wait_time * 60 * 1000
                    ).format("hh") +
                      " hh : " +
                      moment(
                        props &&
                          props.logData &&
                          props.logData.diner_id &&
                          props.logData.diner_id.wait_time * 60 * 1000
                      ).format("mm") +
                      " mins"}
                  </span>
                ) : (
                  <> </>
                )}
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 mb-3">Date & Time</div>
              <div className="f10-400">
                {" "}
                {moment(
                  props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.reservationTime
                ).format("DD MMM, YYYY")}
              </div>
              <div className="f10-400">
                {moment(
                  props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.reservationTime
                ).format("LT")}
              </div>
            </Col>
            <Col lg={9} md={6} className="py-3">
              <div className="d-flex flex-wrap align-items-center justify-content-end">
                <CallingButtonPopup
                  sendData={makeCallingObject(props.logData)}
                />
                <Button variant="link" className="enIconBtn mr-3">
                  <Image
                    src={require("../../../../../assets/images/UserManagement/forum.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>
                <SuperAdminSmsAdmin
                  mobile_number={`${props?.logData?.user_id?.country_code}${props?.logData?.user_id?.mobile_number}`}
                  first_name={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id.first_name
                  }
                />
                <CustomSuperAdminNotification
                  _id={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id._id
                  }
                />
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 mb-3">Table / Room No.</div>
              <div className="f10-400">Outdoor /</div>
              <div className="f10-400">
                Table No. -
                {props.logData &&
                  props.logData.diner_id &&
                  props.logData.diner_id.table_number}
              </div>
              <div className="f10-400">
                Room No. -
                {props.logData &&
                  props.logData.diner_id &&
                  props.logData.diner_id.room_number}
              </div>
            </Col>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 pb-3">Special Occasion</div>
              <div className="f10-400">
                {props &&
                  props.logData &&
                  props.logData.diner_id &&
                  props.logData.diner_id.occasion}
              </div>
              {/* <Button variant="link" className="text-red f12-400 p-0">
                See more more
              </Button> */}
            </Col>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 pb-3">Status</div>
              <div className="f13-400">
                <span className="enYellowDot mr-1"></span>
                {props &&
                  props.logData &&
                  props.logData.diner_id &&
                  props.logData.diner_id.diner_status}
              </div>
            </Col>
            <Col lg={3} md={6} className="py-3">
              <div className="f12-500 mb-3">Seating Preference</div>
              <div className="f10-500">Outdoor</div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="open_issues_view_tickets_right mt-2">
        <div className="px-4 py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center f12-500">
              {props.showChat && (
                <i
                  className="fa fa-long-arrow-left mr-3 cursor-pointer"
                  aria-hidden="true"
                  onClick={props.onClickShowLog}
                ></i>
              )}
              Resolution Log
            </div>
            {/* <NavLink
              to=""
              onClick={() => alert("Sd")}
              className="f12-500 text-blue"
            >
              View all
            </NavLink> */}
            {props.showLog ? (
              <span
                onClick={() => props.handleChatSHow()}
                className="f12-500 text-blue cursor"
              >
                View all
              </span>
            ) : (
              <> </>
            )}
          </div>
        </div>

        {props.showLog && (
          <Table className="w-100 enResolutionLogTBL">
            <thead>
              <tr>
                <th style={{ width: "20%" }} className="pl-4">
                  <div className="f10-500">Date</div>
                </th>
                <th style={{ width: "60%" }}>
                  <div className="f10-500">Comments</div>
                </th>
                <th style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-500">Comments By</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {logData.ticketLogs.map((log,index)=>())} */}

              {logData.map((log, index) => (
                <tr key={index}>
                  <td style={{ width: "20%" }} className="pl-4">
                    <div className="f10-400">
                      {" "}
                      {moment(log.time).format("MMMM Do YYYY")}
                    </div>
                    <div className="f10-500">
                      {moment(log.time).format("LT")}
                    </div>
                  </td>
                  <td style={{ width: "60%" }}>
                    <div className="f10-400">{log.content}</div>
                  </td>
                  <td style={{ width: "20%" }} className="pr-4 text-center">
                    <div className="f10-400">You</div>
                  </td>
                </tr>
              ))}
              {/* <tr>
                <td style={{ width: "20%" }} className="pl-4">
                  <div className="f10-400">13th August, 2019</div>
                  <div className="f10-500">06:30 PM</div>
                </td>
                <td style={{ width: "60%" }}>
                  <div className="f10-400">
                    Seating status changed from not no t seated to seated
                  </div>
                </td>
                <td style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-400">User</div>
                </td>
              </tr>
              <tr>
                <td style={{ width: "20%" }} className="pl-4">
                  <div className="f10-400">13th August, 2019</div>
                  <div className="f10-500">06:30 PM</div>
                </td>
                <td style={{ width: "60%" }}>
                  <div className="f10-400">
                    Seating status changed from not seated to seated
                  </div>
                </td>
                <td style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-400">You</div>
                </td>
              </tr> */}
            </tbody>
          </Table>
        )}

        {props.showChat && (
          <React.Fragment>
            <div className="col-12 open_issues_view_tickets_chat_screen">
              <div className="display-chat-screen-one">
                <div>
                  <h3>
                    {props && props.logData && props.logData.seating_request_no}
                  </h3>
                  <p className="bottom-text color-gray">Request Number</p>
                </div>
              </div>
              <div className="col-12 open_issues_view_tickets_chat_screen">
                <div className="chat-screen-max-height" id="style-4">
                  <ChatScreenTrack
                    comment={props && props.logData && props.logData.comment}
                    auth={props && props.auth}
                  />
                </div>
              </div>
            </div>
            <div className="chat-submit-button">
              <div>
                <div className="input-group button-chat-box">
                  <input
                    type="text"
                    className="form-control input-box-height"
                    placeholder="Write your comment"
                    aria-label="Write your comment"
                    aria-describedby="button-addon2"
                    value={props.message}
                    onChange={(e) => props.setMessage(e.target.value)}
                  />
                  <div className="input-group-append chat-button-box">
                    <div className="enChatFileUploadBtn">
                      <input type="file" />
                      <Image
                        fluid
                        alt="Back Icon"
                        title="Back Icon"
                        className="mr-2"
                        src={require("../../../../../assets/images/UserManagement/paper-clip.svg")}
                      />
                    </div>
                    <button
                      className="chat-button-box-button"
                      type="button"
                      id="button-addon2"
                      onClick={props.onClickAddComment}
                    >
                      <i
                        className="font-awesome-flag-size fa fa-paper-plane-o"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
